<template>
<div style="width:100%;height:100%;overflow-y:hidden;background-color:gainsboro;" ref='CanvasWrapper'> 
  <div id="Maps" style="overflow-y:scroll;height:100%;">  
    <!-- 【Cookie】<br>
    num_canvas:<pre v-html="getCookie('num_canvas')"></pre>
    num_fav:<pre v-html="getCookie('num_fav')"></pre>
    num_fav_max: <pre v-html="getCookie('num_fav_max')"></pre>
    num_canvas_max: <pre v-html="getCookie('num_canvas_max')"></pre>
    canvases: <pre v-html="getCookie('canvases')"></pre>
    【Cookie】
    <button @click="ClearCookies()">Cookie クリア</button> -->

    <!-- 表示する地図がない場合 -->
    <div v-if="num_canvases == 0" style="width:100%;height:100%;color:grey; font-size:30px;"> 
      <span style="margin:auto">
        表示する地図がありません 
      </span>
    </div>
    <!-- 表示する地図がない場合 -->

    <draggable 
        tag="div" 
        v-model="canvases" 
        @update = "ResetCookies" 
        ghost-class="ghost" 
        :options="{handle:'.MapTitle'}"
        class="list-group"
        v-bind="dragOptions"
        @start="drag = true"
        @end="drag = false"
    >

      <transition-group type="transition" :name="'flip-list'" :class="[if_sp ? 'notflex_wrap' : 'flex_wrap']">
        <div
          v-for="(canvas, index) in filtered_canvases"
          :key="canvas.index"
          :class="[
            if_sp ? 'vfor-list-item' : 'vfor-list-item_flex'
          ]"
        >
              <div class="swipe_wrap">
                <span class="over" :ref='"over"+String(index)'><span class = "over-cell">削除</span></span> 
                
                <span class="fav" :ref='"fav"+String(index)'><span class = "fav-cell">お気に入り登録/解除</span></span> 
                
                <div class="MapCard" :ref='"swipe"+String(index)' >                
                  <div class = "MapTitle">
                    <span v-if="!if_sp" class="fav-mark">
                      <button v-if="canvas.fav" v-on:click="favoritebutton(index)">★</button>
                      
                    </span>
                    <span v-if="!if_sp" class="fav-mark_off">
                      <button v-if="!canvas.fav" v-on:click="favoritebutton(index)">☆</button>
                    </span>
                    
                    <span v-if="if_sp">
                      <span v-if="canvas.fav" class="fav-mark">★</span>
                      <span v-if="!canvas.fav" class="fav-mark_off">☆</span>
                    </span>

                    {{canvas.title}}

                    <span v-if="!if_sp && !fav_filter" class="delete_button">
                      <button v-on:click="deltebutton(index)">×</button>            
                    </span>
                  </div>

                  <div  v-if="if_sp" @touchend="touchEnd(index, $event)" @touchstart="touchStart" @touchmove="touchMove(index, $event)" @mousemove="touchMove"> 
                    <transition><canvas-item class="canvas_item" :data="canvas" /></transition>  
                  </div>
                  <div v-if="!if_sp">   
                    <transition><canvas-item class="canvas_item" :data="canvas" /></transition>   
                  </div>         
                     
                </div>   
              </div> 
        </div>
      </transition-group>
    </draggable>
  </div>
  
</div>
</template>

<script>
import axios from 'axios';
import CanvasCard from './canvas'
import draggable from 'vuedraggable'

var data_root = "./data"
var access_points_json =data_root+"/"+"ap.json";
var ap_data_json =data_root+"/"+"ap-data2.json";
var floors_json =data_root+"/"+"floors.json";

var index_count = 0;


export default {
  name: 'Map', 
  display: "Transitions", 
  components: {
    'canvas-item': CanvasCard,
    draggable,    
  },
  props:{
    fav_filter:{
      type: Boolean,
      default: true
    },
    if_sp:{
      type: Boolean,
      default: true
    },

  },
  watch:{
    GetMapState_floor(val){
      this.floor = val
      let img_file = ""
      let title = ""
      axios.get(floors_json).then(floor_data => {
        this.floors = Object.keys(floor_data.data).map(function (key) {return floor_data.data[key]})

        let floors_filtered = this.floors.filter( (value) => {
          return (value['id'] == this.floor)
        })
        img_file = floors_filtered[0]["image_filename"]
        title = floors_filtered[0]["floor_name"]

      axios.get(access_points_json).then(response => {
        this.aps = Object.keys(response.data).map(function (key) {return response.data[key]})

        let aps_filtered = this.aps.filter( (value) => {
          return (value['floor_id'] == this.floor)
        })
        this.access_points  = aps_filtered

          axios.get(ap_data_json).then(ap_data => {
            this.ap_data = []
            let aps_filtered_filtered = []
            for(let ap in aps_filtered){ 
              if(ap_data.data[aps_filtered[ap]['ap_name']]){
                this.ap_data.push(ap_data.data[aps_filtered[ap]['ap_name']].numClient)
                aps_filtered_filtered.push(aps_filtered[ap])
              }
            }
        axios.get("./building_images/"+img_file+"-angle.png").then(response =>{
          console.log(response)
          this.AddCanvas("./building_images/"+img_file+"-angle.png", title, aps_filtered_filtered, this.ap_data, this.floor);
        }).catch(err=>{console.log(err, "画像がありませんでした")})
        
        }).catch(err => {console.error(err)})
        }).catch(err => {console.error(err)})      
        }).catch(err => {console.error(err)})
        return val;
    },
    GetMapState_building(val){this.building = val},
    GetMapState_campus(val){this.campus = val},
  },
  computed:{
    GetMapState_floor(){return this.$store.getters.GetMapState.floor_selected},
    GetMapState_building(){return this.$store.getters.GetMapState.building_selected},
    GetMapState_campus(){return this.$store.getters.GetMapState.campus_selected},
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    filtered_canvases: function(){
      return this.canvases.filter(function (el) {
        if(this.fav_filter) return el.fav  == true
        else return true
      }, this)
    },
    num_canvases: function(){
      return this.filtered_canvases.length;
    }
  },
  data: () =>  {
    return {
      campus: -1, building: -1, floor: -1,
      access_points: null,
      canvases:[],
      options: {
        responsive: true
      },
      floors: [], aps: [], ap_data: [],
      drag:false
    }
  },
  methods: {
    deltebutton(index){
      this.canvases[index].disable = true;
      this.PopCanvas(index);        
    },
    favoritebutton(index){
      this.ToggleFavMap(index);
    },
    touchStart(e){
      this.startX = e.touches[0].pageX;      
    },
    touchMove(index, e){
      this.position = 0;
      this.moveX = e.touches[0].pageX - this.startX;
      this.$refs['swipe'+String(index)][0].style.transform = `translate3d(${this.moveX + this.position}px,0,0)`;
      if(this.moveX > 0.0){
        this.$refs['over'+String(index)][0].style.width = String(this.$refs['swipe'+String(index)][0].clientWidth)+"px";
        this.$refs['over'+String(index)][0].style.height = String(this.$refs['swipe'+String(index)][0].clientHeight)+"px";
        this.$refs['over'+String(index)][0].style.opacity = this.moveX/100 - 0.4 
      }
      else{
        this.$refs['fav'+String(index)][0].style.width = String(this.$refs['swipe'+String(index)][0].clientWidth)+"px";
        this.$refs['fav'+String(index)][0].style.height = String(this.$refs['swipe'+String(index)][0].clientHeight)+"px";
        this.$refs['fav'+String(index)][0].style.opacity = -this.moveX/100 - 0.4   
      }
    },
    touchEnd(index, e){
      console.log("garbage", e)
      if(this.moveX/100- 0.8 > 1.0) this.PopCanvas(index)
      if(-this.moveX/100- 0.8 > 1.0) this.ToggleFavMap(index)
      this.$refs['swipe'+String(index)][0].style.transform = `translate3d(0px,0,0)`;   
      this.$refs['over'+String(index)][0].style.height = "0px"
      this.$refs['over'+String(index)][0].style.opacity = 0; 
      this.$refs['fav'+String(index)][0].style.height = "0px"
      this.$refs['fav'+String(index)][0].style.opacity = 0;   
    },
    AddCanvas(fileData, title, access_points, ap_data, floor, if_cookie = true, fav = false){
      let if_double = false;
      let hit = -1;
      for(let i = 0; i < this.canvases.length; i++){
        if(floor == this.canvases[i]["floor"]){
          if_double = true; hit = i;
        }
      }
      if(if_double){
        let buf = this.canvases[hit]
        this.canvases.splice(hit, 1)
        this.canvases.unshift(buf)
        this.ResetCookies()
      }
      else{
        if(if_cookie){
          var num_max = 9
          var num = Number(this.getCookie("num_canvas"))
          var b = this.getCookie('canvases')
          if(num+1 > num_max){
            this.setCookie('num_canvas', num)
            for(let i=num-1; -1 < i; i--){
              if(!this.canvases[i].fav){
                  b.data.splice(i, 1)
                  this.canvases.splice(i, 1)
                  break;
              }
            }
          }
          else{
            this.setCookie('num_canvas', num+1)
          }            
          b.data.unshift({"floor": floor, "fav": false})
          this.setCookie('canvases', JSON.stringify(b))
        }
        this.canvases.unshift(
          {
            fileData: fileData,
            access_points: access_points,
            ap_data: ap_data,
            index: index_count,
            floor: floor,
            title: title,
            fav:fav,
          }
        );
        index_count++;
      }
    },
    ClearCookies: function(){
      this.setCookie('num_canvas', 0)
      this.setCookie('num_canvas_max', 5)
      this.setCookie('num_fav_max', 3)
      this.setCookie('num_fav', 0)
      this.setCookie('canvases', JSON.stringify({data:[]}))
    },
    ToggleFavMap: function(index){
      if(this.fav_filter){
        var buf = index;
        var count = 0;
        for(let i = 0; i < this.canvases.length; i++){
          if(this.canvases[i].fav){
            if(count == index){
              buf = i;
              break;
            }
            count++;
          }
        }
        index = buf;        
      }
      this.canvases[index].fav = !this.canvases[index].fav;
      var num = Number(this.getCookie("num_fav"))  
      if(this.canvases[index].fav){this.setCookie("num_fav", num+1);}
      else{this.setCookie("num_fav", num-1);}
      this.ResetCookies()
    },
    PopCanvas: function(index){
      this.deleteItem(index);
      this.ResetCookies()
    },
          ResetCookies: function(){
            var num = this.canvases.length
            var arr = []
            for(let j = 0; j < this.canvases.length; j++){
              arr.push({"floor": this.canvases[j].floor, "fav": this.canvases[j].fav})
            }
            let fav = this.canvases.filter((value) => {
              return (value['fav'] == true)
            })
            this.setCookie('num_canvas_max', 5)
            this.setCookie('num_fav_max', 3)
            this.setCookie('num_canvas', num)
            this.setCookie('num_fav', fav.length)
            this.setCookie('canvases', JSON.stringify({data:arr}))
          },
          deleteItem: function(index){
            this.canvases.splice(index, 1);
          },
    getCookie:function(key){
      return this.$cookies.get(key)
    },
    setCookie:function(key, text){
      this.$cookies.config(60 * 60 * 24 * 30,'');
      this.$cookies.set(key, text);
    },
    RebuildMaps: async function(){
      var num = Number(this.getCookie("num_canvas"))
      var b = this.getCookie('canvases')
      b.data = b.data.reverse()
      const process_bef =  async function(){
        var local_floor = await axios.get(floors_json)
        var local_ap = await axios.get(access_points_json)
        var local_ap_data = await axios.get(ap_data_json)
        return [local_floor, local_ap, local_ap_data]
      }
      const process_aft = async function(result, func, val, num){
        for(let j=0; j < num; j++){
          var l_f = result[0]; var l_a = result[1]; var l_a_d = result[2];

          let img_file = ""
          let title = "";
          var floors = Object.keys(l_f.data).map(function (key) {return l_f.data[key]})

            let floors_filtered = floors.filter( (value) => {
              return (value['id'] == val[j]["floor"])
            })
            img_file = floors_filtered[0]["image_filename"]
            title = floors_filtered[0]["floor_name"]

          var aps = Object.keys(l_a.data).map(function (key) {return l_a.data[key]})

            let aps_filtered = aps.filter( (value) => {
              return (value['floor_id'] == val[j]["floor"])
            })
          var ap_data = []
          var aps_filtered_filtered = []
            for(let ap in aps_filtered){
              if(l_a_d.data[aps_filtered[ap]['ap_name']]) {
                ap_data.push(l_a_d.data[aps_filtered[ap]['ap_name']].numClient)
                aps_filtered_filtered.push(aps_filtered[ap])
              }
            }
          func("./building_images/"+img_file+"-angle.png", title, aps_filtered_filtered, ap_data, val[j]["floor"], false, val[j]["fav"]);
        }
      }
      const process_close = async function(func){
        func();
      }
      const processAll = async function(func, func_cl, val, num) {
        var res = await process_bef();
        await process_aft(res, func, val, num);
        await process_close(func_cl);
      }
      processAll(this.AddCanvas, this.ResetCookies, b.data, num)
    }
  },
  mounted() {
    if(this.getCookie('num_canvas') == null){this.ClearCookies()}
    else{this.RebuildMaps()}    
  }  
}
</script>

<style>

.flex_wrap{
  display:flex;
  flex-wrap:wrap;
}
.fav, .over{
  z-index: 2;
  position: absolute;
  right: 0px; bottom: 0px;
  opacity: 0;
  display: table;
  margin:0;
  padding:0;
}
.over{
  background: linear-gradient(to right , rgba(255, 255, 255, 0),rgba(255, 255, 255, 0) 50%, rgba(100, 100, 100, 0.8) 70%, rgba(0, 0, 0, 0.8) 99%,rgba(255, 255, 255, 0) 100%);  
  color:rgba(255, 255, 255, 0.5);
  text-align: right;
}
.fav{
  background: linear-gradient(to left , rgba(255, 255, 255, 0),rgba(255, 255, 255, 0) 50%, rgba(237, 252, 153, 0.8) 70%, rgba(255, 252, 77, 0.842) 99%, rgba(255, 255, 255, 0) 100%);  
  color:rgba(0, 0, 0, 0.7);
  text-align: left;
}

.over-cell, .fav-cell{
  font-size:20px;
  display: table-cell; /* 子要素はテーブルセル要素にする */
  vertical-align: middle; /* 上下中央に寄せる */ 
}

.MapCard, .swipe_wrap{
  height:auto;
  position: relative;
  z-index:1;
  overflow:hidden;
  border-radius: 5px;
  margin:2px;
}
.swipe_wrap{
  transform:translate3d(0px,0,0)
}

.flip-list-move {
  transition: transform 0.5s;
}
.flip-list {
  transition: transform 0.5s;
}
.flip-list-enter, .flip-list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.flip-list-leave-active {
  position: absolute;
}

.vfor-list-item {
  /* transition: transform 0.5s; */
  transition: transform 0.5s;
  /* transition: move 0s; */
  cursor: move;
}
.vfor-list-item_flex {
  transition: all 0.5s;
  display:flex;
  flex-wrap:wrap;
  width:33%;
}

.ghost .canvas-item{
  opacity: 0.5;
  background: #c8ebfb;
}
.MapTitle{
  font-size:22px;
  padding-left: 10px;
  background-color: rgb(56, 80, 57);
  color: white;
  width:100%;
  height: 35px;
}
.ghost .MapTitle, .MapTitle:active, .MapTitle:hover{
  opacity: 0.5;
}
.fav-mark{
  color:yellow; 
  text-align:right;
}
.fav-mark:hover{
  color:red;
}
.fav-mark_off{
  color:white; 
  text-align:right;
}
.fav-mark_off:hover{
  color:red;
}
.delete_button{
  float:right; margin-right:10px;font-size:30px;
}
.delete_button:hover{
  color:red;
}

</style>
